//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getToken, service } from "../services/api";
import EntryDialog from "./EntryDialog.vue";
import DeleteEntryDialog from "./DeleteEntryDialog.vue";
import EditEntryDialog from "./EditEntryDialog.vue";
import SnackBar from "./SnackBar.vue";
import SnackBarMixin from "./SnackBarMixin.vue";

export default {
  extends: SnackBarMixin,
  components: {
    snackbar: SnackBar,
    "edit-entry-dialog": EditEntryDialog,
    "delete-entry-dialog": DeleteEntryDialog,
    "entry-dialog": EntryDialog,
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
        },
        { text: "Value", value: "value" },
        { text: "Operation Type", value: "type" },
        { text: "Operation Date", value: "date" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      entries: [],
    };
  },
  methods: {
    getColor(value) {
      return value == "Receiving" ? "#36b09a" : "#b0364a";
    },
    getFilteredEntries() {
      if (!this.search) {
        return this.headers;
      }
      return this.headers.filter((h) => h.description.includes(this.search));
    },
    getFormattedDate(value) {
      return new Date(value).toLocaleDateString("en-US");
    },
    getFormattedValue(value) {
      const valueFormat = Intl.NumberFormat("en-US");
      return `$ ${valueFormat.format(value)}`;
    },
    getFinancialEntries() {
      const token = getToken();
      service.getAllEntries(token).then((res) => (this.entries = res.data));
    },
    updateAddedEntry(value) {
      const token = getToken();
      service
        .newEntry(token, value)
        .then((res) => {
          this.showSuccess("Entry Successfully Added");
          this.entries.push(res.data);
        })
        .catch(() => {
          this.showError("Failed Adding Entry");
        });
    },
    editAddedEntry(value) {
      const token = getToken();
      service
        .editEntry(token, value)
        .then((res) => {
          const index = this.entries.indexOf(
            this.entries.filter((e) => e.id == value.id)[0]
          );
          this.entries.splice(index, 1, res.data);
          this.showSuccess("Entry Successfully Updated");
        })
        .catch(() => {
          this.showError("Failed Updating Entry");
        });
    },
    removeEntry(value) {
      const token = getToken();
      service
        .removeEntry(token, value)
        .then(() => {
          this.showSuccess("Entry Successfully Removed");
          service.getAllEntries(token).then((res) => (this.entries = res.data));
        })
        .catch(() => {
          this.showError("Failed Removing Entry");
        });
    },
  },
  created() {
    this.getFinancialEntries();
  },
};
